import { Component, OnInit } from '@angular/core';
import {AhmService} from '../../services/ahm.service';
import {NavigationService} from '../../services/navigation.service';
import {Router} from '@angular/router';


@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {

  backButtonDisplay = 'none';

  constructor(private service: AhmService, private navigation: NavigationService, private router: Router) { }

  ngOnInit() {
    AhmService.prototype.setNavigationComponentLink(this);
  }

  /**
   * navigate to home page
   */
  homePage() {
    // 'home' and '/' are home pages. to start navigation we need to set different location
    // todo: find force navigate to refresh page
    const currentUrl = this.router.url;
    if (-1 !== currentUrl.indexOf('home')) {
      this.router.navigate(['']);
    } else {
      this.router.navigate(['home']);
    }
    // todo: fix it
    // hide login form when press home button
    if ('<b>Not<br/>Signed In</br>' === this.service.homeComponentLink.signedInSpan) {
      this.service.showLoginForm();
    } else {
      // hide login form when press home button
      setTimeout(() => {
        this.service.hideLoginForm();
      });
    }
  }

}
